import { IProductListItem } from 'api/types';

const ATTRIBUTE_LABEL_MAP: Record<string, string> = {
  'Nowość': 'NOWOSC',
  'Promocja': 'PROMOCJA',
  'Bestseller': 'BESTSELLER',
  'Bez SUP': 'BEZ_SUP',
  'Twój nadruk': 'TWOJ_NADRUK',
  'Premium': 'PREMIUM'
};

const normalizeUnicode = (str: string): string => {
  return str.replace(/\u015b/g, 'ś').replace(/\u0107/g, 'ć').replace(/\u00f3/g, 'ó').trim();
};

export const getProductLabels = (product: IProductListItem): Array<{ type: string; name: string }> => {
  const labels: Array<{ type: string; name: string }> = [];
  
  product.product_attribute_short_info?.attributes?.forEach((attr) => {
    if (!attr.name) return;
    
    const normalized = normalizeUnicode(attr.name);
    const labelType = ATTRIBUTE_LABEL_MAP[attr.name] || ATTRIBUTE_LABEL_MAP[normalized];
    
    if (labelType) {
      labels.push({ type: labelType, name: attr.name });
    }
  });

  const allLabels = [...(product.product_basic_short_info?.labels || []), ...labels];
  
  return allLabels.filter((label, index, self) =>
    index === self.findIndex((l) => l.type === label.type)
  );
};

